import { gql } from '@apollo/client';

export const EXTRACT_VIDEO_AUDIO = gql`
    mutation($data: ExtractVideoAudioInput!) {
        extractVideoAudio(data: $data) {
            id
            title
            body
            createdAt
            updatedAt
            file {
                url
                thumbnail {
                    sm
                    md
                    lg
                    xl
                    original
                    compressed {
                        sm
                        md
                        lg
                        xl
                        original
                    }
                }
                name
                displayName
                type
                format
                size
                mime
                duration
            }
        }
    }
`;
